import Swal from "sweetalert2";
import { getCsrfToken } from "../utils/AuthUtils";

/**
 * Bandeau d'usurpation d'identite, et sa sortie.
 *
 * Le bandeau est declare dans le layout, donc present sur toutes les pages de l'application ;
 * `window.impersonating` dit s'il faut le montrer. `window.user` est ici le compte **usurpe**,
 * l'authentification ayant substitue l'identite.
 */
$(function () {
    if (window.impersonating !== true) {
        return;
    }

    $("#impersonationName").text(window.user?.name ?? "");
    $("#impersonationBanner").removeClass("d-none").addClass("d-flex");

    $("#impersonationExit").on("click", () => {
        $.ajax({
            url: "/admin/users/revertIdentity.json",
            type: "POST",
            cache: false,
            headers: {
                "X-CSRF-Token": getCsrfToken(),
            },
            dataType: "json",
            success() {
                window.location.href = "/dashboard";
            },
            error(error) {
                console.error(error);
                Swal.fire("Erreur!", "Impossible de reprendre votre compte", "error");
            },
        });
    });
});
